import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { BadgeScore } from './BadgeScore';

type Props = { score: number };
export function PetitionStrengthCard({ score }: Props): JSX.Element {
	return (
		<div className="stroke-weaker flex h-full max-h-[138px] w-[186px] flex-col gap-[11px] rounded-xl border bg-background-base p-5 elevation-low">
			<Text as="p" size="xx-small" variant="heading" className="lowercase first-letter:uppercase">
				<Translate value="corgi.petition.details.strength_score.title" />
			</Text>
			<BadgeScore
				score={score}
				sx={{
					'& #score-text': { fontSize: '14px' },
				}}
			/>
		</div>
	);
}
